import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Comment } from '../../../../../models/comments/comments';
import { LoaderService } from 'src/app/services/loader.service';
import { ActivatedRoute } from '@angular/router';
import { CommentsService } from 'src/app/services/comments.service';
import { EVENT_TYPES, GaAnalyticsService } from 'src/app/services/ga-analytics.service';
import { AppSetting } from 'src/app/global/appsetting';
import { ProductDetailsUiStateService } from '../../product-details-ui-state.service';
@Component({
  selector: 'app-comment-form',
  templateUrl: './comment-form.component.html',
  styleUrls: ['./comment-form.component.scss']
})
export class CommentFormComponent implements OnInit {

   displayCommentForm = this._pUiService.displayCommentForm;
  stars = this._pUiService.stars;
  
  souldHideForm = true;
  comment: Comment;
  fieldHasError = [false, false];
  
  starsArray = [1, 2, 3, 4, 5];
  captchaResponse = '';
  displayError = false;
  displaySuccess = false;
  displayGoogleRobot = true;
  displayEmailError = false;
  recaptchaKey: string;
  
  constructor(
    public loaderService: LoaderService,
    private route: ActivatedRoute,
    public commentsService: CommentsService,
    private gaAnalyticsService: GaAnalyticsService,
    public appSetting: AppSetting,
    private _pUiService: ProductDetailsUiStateService,
    ){
      this.recaptchaKey = this.appSetting.reCaptchaKey;
  }
  ngOnInit(): void {
    this.comment = new Comment();
    this.comment.Stars = this.stars;    
  }

  hideForm(): void {
    if (this.souldHideForm) {
      this._pUiService.displayCommentFormChange(false);
      this._pUiService.changeFullOpacityState();
      document.querySelector('.anim-to-disable')?.classList.remove('disable-anim');
      this.comment.Stars = 0;
    }
    this.souldHideForm = true;
  }

  preventDefault(): void {
    this.souldHideForm = false;
  }

  setStar(index): void {
    this._pUiService.starsChange(index+1);
  }

  sendComment(): void {
    if (this.validateField()) {
      this.displayError = false;
      this.displaySuccess = false;
      this.loaderService.displayLoader(false);
      const productId = this.route.snapshot.params.id;
      this.comment.ProductId = productId;
      this.commentsService.InsertComment(this.comment, this.captchaResponse).subscribe((res: boolean) => {
        this.loaderService.hideLoader();
        this._pUiService.displayCommentFormChange(false);
        this._pUiService.changeFullOpacityState();
        document.querySelector('.anim-to-disable')?.classList.remove('disable-anim');
        this.comment = new Comment();
        if (res === true) {
          this.displaySuccess = true;
          // this.getAllPost();
        } else {
          this.displayError = true;
        }
        this.displayGoogleRobot = false;
        window.setTimeout(() => {
          this.displayGoogleRobot = true;
        }, 1000);
      }, error => {
        this.gaAnalyticsService.logEventToGa('sendComment', 'CommentsComponent', EVENT_TYPES.Error);
        this.loaderService.hideLoader();
        this.displayGoogleRobot = false;
        window.setTimeout(() => {
          this.displayGoogleRobot = true;
        }, 1000);
        this.displayError = true;
      }
      );
    }

  }

  validateField(): boolean {
    this.fieldHasError = [false, false, false];
    let res = true;
    if (this.comment.Name === '' || this.comment.Name == null) {
      this.fieldHasError[0] = true;
      res = false;
    }
    // tslint:disable-next-line: max-line-length
    const pattern = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (this.comment.UserEmail === '' || this.comment.UserEmail == null || !pattern.test(this.comment.UserEmail.toLowerCase())) {
      this.fieldHasError[1] = true;
      res = false;
    }
    if (this.captchaResponse === '') {
      this.fieldHasError[2] = true;
      res = false;
    }
    return res;
  }

  checkEmail(): void {
    this.displayEmailError = false;
    this.commentsService.TestIfUserExist(this.comment.UserEmail).subscribe((res) => {
      if (!res) {
        this.displayEmailError = true;
      }
    }, 
    error=>{
      this.gaAnalyticsService.logEventToGa('sendComment', 'CommentsComponent', EVENT_TYPES.Error);
    });
  }
  
  resolved(captchaResponse: string): void {
    this.captchaResponse = captchaResponse;
    console.log(`Resolved captcha with response ${captchaResponse}:`);
  }

  displayCommentFormChange(val: boolean): void{
    this._pUiService.displayCommentFormChange(val)
  }

}
